import { qs, esc } from "../inc/dom.js";

const initSearch = () => {
    const root = qs("[data-search]");
    if (!root) return;

    const listEl = qs("[data-search-results]", root);
    const countEl = qs("[data-search-count]", root);
    const emptyEl = qs("[data-search-empty]", root);
    const loaderEl = qs("[data-search-loader]", root);
    const query = (root.getAttribute("data-search-query") || "").trim().toLowerCase();

    const setLoading = (on) => {
        if (loaderEl) loaderEl.hidden = !on;
    };

    const rowLabels = (row) =>
        Object.keys(row)
            .filter((key) => key !== "href" && row[key])
            .map((key) => ({ type: key, text: String(row[key]) }));

    const render = (matches) => {
        if (!listEl) return;
        listEl.innerHTML = matches
            .map(
                (match) =>
                    `<a class="search-result" href="${esc(match.href)}"><span class="search-result-text">${esc(match.text)}</span><span class="search-result-type">${esc(match.type)}</span></a>`
            )
            .join("");
        if (countEl) {
            countEl.textContent = matches.length
                ? `${matches.length} result${matches.length === 1 ? "" : "s"} for "${query}"`
                : "";
        }
        if (emptyEl) emptyEl.hidden = matches.length !== 0;
    };

    if (!query) {
        setLoading(false);
        if (emptyEl) emptyEl.hidden = false;
        return;
    }

    setLoading(true);
    fetch("/sitesearch.json", { headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then((res) => res.json())
        .then((rows) => {
            const matches = [];
            (Array.isArray(rows) ? rows : []).forEach((row) => {
                rowLabels(row).forEach((label) => {
                    if (label.text.toLowerCase().includes(query)) {
                        matches.push({ href: row.href, text: label.text, type: label.type });
                    }
                });
            });
            render(matches);
        })
        .catch(() => render([]))
        .then(() => setLoading(false));
};

initSearch();
